import {useState} from "react";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";

const isGooglePlacesReady = () =>
  typeof window !== "undefined" &&
  Boolean(window.google?.maps?.places);

const getSelectedAddressLabel = (value) => {
  if (typeof value === "string") return value;
  return value?.label || value?.value?.description || "";
};

/**
 * Prevents react-google-places-autocomplete from crashing the whole React tree
 * when its browser API key is missing or when the Google script cannot load.
 */
const SafeGooglePlacesAutocomplete = ({
  apiKey = "",
  onLoadFailed,
  selectProps = {},
  ...props
}) => {
  const [loadError, setLoadError] = useState(null);
  const canUseGooglePlaces = Boolean(apiKey) || isGooglePlacesReady();

  if (!canUseGooglePlaces || loadError) {
    const selectedAddressLabel = getSelectedAddressLabel(selectProps.value);
    const message = !canUseGooglePlaces
      ? "La recherche d'adresse est temporairement indisponible."
      : "Le service de recherche d'adresse n'a pas pu être chargé.";

    return (
      <div>
        <input
          id={selectProps.inputId}
          type="text"
          className="form-control"
          value={selectedAddressLabel}
          placeholder={selectProps.placeholder || "Recherchez une adresse..."}
          disabled
          aria-describedby={
            selectProps.inputId ? `${selectProps.inputId}-google-places-error` : undefined
          }
        />
        {selectedAddressLabel && selectProps.isClearable && (
          <button
            type="button"
            className="mt-2 border-0 bg-transparent p-0 text-sm text-danger underline"
            onClick={() => selectProps.onChange?.(null, {action: "clear"})}
          >
            Supprimer l'adresse
          </button>
        )}
        <div
          id={
            selectProps.inputId ? `${selectProps.inputId}-google-places-error` : undefined
          }
          className="mt-1 text-xs text-danger"
          role="alert"
        >
          {message} Veuillez réessayer dans quelques instants.
        </div>
      </div>
    );
  }

  return (
    <GooglePlacesAutocomplete
      {...props}
      apiKey={apiKey}
      selectProps={selectProps}
      onLoadFailed={(error) => {
        setLoadError(error || new Error("Google Places indisponible"));
        onLoadFailed?.(error);
      }}
    />
  );
};

export default SafeGooglePlacesAutocomplete;
